<template>
  <div v-if="isUserAuthenticated()">
    <v-dialog
      :value="value"
      persistent
      max-width="400"
    >
      <v-card>
        <v-card-title class="headline">
          {{ this.Title }}
        </v-card-title>
        <v-card-text>
          {{ this.Message }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click.native="close">Non</v-btn>
          <v-btn color="blue darken-1" flat @click.native="confirm">Oui</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
  import auth from '@/auth'
  import TemplateAdminComponent from '@/components/TemplateAdmin.vue'

  export default {
    props: {
      Title : {type: String, required: true},
      Message: {type: String, required: true },
      CallBackYes: { type: Function, required: true },
      value: { type: Boolean, required: true },
    },
    components:
    {
      TemplateAdminComponent,
    },
    data() {
      return {
      }
    },
    methods: {
      isUserAuthenticated() {
        return auth.isUserAuthenticated()
      },
      confirm() {
        this.CallBackYes()
      },
      close () {
        this.$emit('input', false)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ModalConfirmation.vue